import { Client } from '@/utils';
import { staff as staffAPI } from '@/api';

const GET_STAFFLIST = "staff/GET_STAFFLIST";
const GET_DEPTANDORG = "staff/GET_DEPTANDORG";
const GET_FUNDOWNER = "staff/GET_FUNDOWNER";


export default {
  state: {
    tableData: {},
    deptAndOrg: [],
    fundOwnerOptions: [],
    statusCount:[
      {status: 0, statusStr: "待开通", count: 0},
      {status: 1, statusStr: "待调整", count: 0},
      {status: 2, statusStr: "已处理", count: 0},
      {status: 3, statusStr: "全部", count: 0}
    ],
  },
  actions: {
    async [GET_STAFFLIST]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(GET_STAFFLIST, await Client.get(staffAPI.queryStaffList, { params }, frontCode));
    },

    async [GET_DEPTANDORG]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(GET_DEPTANDORG, await Client.get(staffAPI.querydeptAndOrg, { params }, frontCode));
    },

    async [GET_FUNDOWNER]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(GET_FUNDOWNER, await Client.get(staffAPI.queryFundOwner, { params }, frontCode));
    },
  },
  mutations: {
    [GET_STAFFLIST](state,data) {
      state.tableData = data.pageUser;
      state.statusCount = data.statusCount;
    },

    [GET_DEPTANDORG](state,data) {
      state.deptAndOrg = data;
    },

    [GET_FUNDOWNER](state,data) {
      state.fundOwnerOptions = data;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/staff.js